import Icon from '@assets/images/Hero-Icone.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './AboutUsTwo.style';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutUsTwo = () => {
  const { t } = useTranslation('aboutUs');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('aboutUsTwo.title.spanBefore')}
          <span>2</span> {t('aboutUsTwo.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>
            {t('aboutUsTwo.subtitle.spanBefore')}
            <span>2</span> {t('aboutUsTwo.subtitle.spanAfter')}
          </p>
          <Link to="/contato" className="link-with-icon">
            <button>{t('aboutUsTwo.button')}</button>
          </Link>
        </TextBox1>
        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AboutUsTwo;
